type AnnouncementIdentity = {
    id?: string | null;
    announcementId?: string | null;
};

type AnnouncementTypeShape = {
    type?: string | null;
    announcementType?: string | null;
};

type AnnouncementDeliveryShape = {
    deliveredPush?: number | null;
    pushSent?: number | null;
    deliveredEmail?: number | null;
    emailSent?: number | null;
    deliveredSms?: number | null;
    smsSent?: number | null;
    failed?: number | null;
    failedDeliveries?: number | null;
};

export const normalizeAnnouncementId = (
    value: string | null | undefined
): string | null => {
    if (!value) return null;

    const trimmed = value.trim();
    if (!trimmed || trimmed === "undefined" || trimmed === "null") {
        return null;
    }

    return trimmed;
};

export const getAnnouncementId = (
    announcement: AnnouncementIdentity | null | undefined
): string | null =>
    normalizeAnnouncementId(announcement?.id) ??
    normalizeAnnouncementId(announcement?.announcementId);

export const getAnnouncementType = (
    announcement: AnnouncementTypeShape | null | undefined
): string | null => announcement?.announcementType ?? announcement?.type ?? null;

export const getAnnouncementPushCount = (
    announcement: AnnouncementDeliveryShape | null | undefined
): number | null => announcement?.pushSent ?? announcement?.deliveredPush ?? null;

export const getAnnouncementEmailCount = (
    announcement: AnnouncementDeliveryShape | null | undefined
): number | null => announcement?.emailSent ?? announcement?.deliveredEmail ?? null;

export const getAnnouncementSmsCount = (
    announcement: AnnouncementDeliveryShape | null | undefined
): number | null => announcement?.smsSent ?? announcement?.deliveredSms ?? null;

export const getAnnouncementFailedCount = (
    announcement: AnnouncementDeliveryShape | null | undefined
): number | null => announcement?.failed ?? announcement?.failedDeliveries ?? null;
